import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TrophyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Trophy",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.84 6.67h-5.06V4.72c0-.64-.52-1.16-1.16-1.16H9.39c-.64 0-1.16.52-1.16 1.16v1.95H3.16C2.52 6.67 2 7.19 2 7.83v2.72c0 1.75 1.09 3.5 3.01 4.89 1.5 1.08 3.32 1.81 5.3 2.03h.05c.83 1.45 1.94 2.65 3.27 3.56l.04.02v3.5h-2.33c-1.75 0-3.11 1.01-3.11 2.72v.59c0 .32.27.58.59.58H23.2c.32 0 .58-.26.59-.58v-.59c0-1.75-1.4-2.72-3.11-2.72h-2.33v-3.5c1.36-.93 2.48-2.13 3.28-3.53l.03-.05c2.03-.22 3.85-.95 5.38-2.05l-.03.02c1.91-1.37 3.01-3.16 3.01-4.89V7.83c0-.65-.52-1.16-1.15-1.16ZM6.83 12.93c-.88-.5-1.53-1.35-1.75-2.35v-.8h3.15c.04 1.51.27 2.95.65 4.32l-.03-.12c-.77-.27-1.44-.62-2.04-1.06l.02.02Zm20.06-2.37c0 .78-.87 1.75-1.75 2.37-.58.42-1.26.77-1.97 1.02l-.06.02c.36-1.25.58-2.69.62-4.17v-.02h3.12z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.48 14.71c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l4.59-4.59c.55-.55.85-1.27.85-2.05s-.3-1.5-.85-2.05a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0 5.19 5.19 0 0 1 0 7.33l-4.59 4.59c-.22.22-.52.33-.81.33ZM8.77 14.71c-.29 0-.58-.11-.81-.33L3.37 9.79a5.19 5.19 0 0 1 0-7.33 1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62-.55.55-.85 1.27-.85 2.05s.3 1.5.85 2.05l4.59 4.59a1.14 1.14 0 0 1-.81 1.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.63 21.57c-.3 0-.59-.12-.81-.33l-6.86-6.86c-.21-.21-.33-.5-.33-.81V1c0-.63.51-1.14 1.14-1.14h13.71c.63 0 1.14.51 1.14 1.14v12.57c0 .3-.12.59-.33.81l-6.86 6.86c-.21.21-.51.33-.81.33ZM9.91 13.1l5.71 5.71 5.71-5.71V2.14H9.9v10.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.34 31.86H9.91c-.63 0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14 1.14-1.14 2.52 0 4.57-2.05 4.57-4.57a1.14 1.14 0 1 1 2.28 0c0 2.52 2.05 4.57 4.57 4.57.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14Zm-10.28-2.29h9.14v-2.38a6.87 6.87 0 0 1-4.57-2.98 6.9 6.9 0 0 1-4.57 2.98z"
      })]
    })
  }));
};